module.exports = __webpack_public_path__ + "assets/img/img28.02ad3a1a.png";